<template>
  <!-- createList dialog -->
  <div class="phrase-overlay">
    <div class="create-phrase-wrap">
      <!-- <el-dialog
    :title="phrase_type=='edit' ? 'メッセージテンプレート編集' : 'メッセージテンプレート作成'"
    :visible.sync="phrase_drawer"
    width="640px"
    top="10vh"
      >-->
      <el-form ref="newlist" style="width:100%" @submit.native.prevent="createPhrase()">
        <div class="list-create">
          <div class="newmessage-title">
            {{ phrase_type == "edit" ? "メッセージテンプレート編集" : "メッセージテンプレート作成" }}
            <div class="flex-space"></div>
            <div class="newmessage-button" @click="phrase_drawer = false">
              <font-awesome-icon :icon="['fal', 'times']" />
            </div>
          </div>
          <div class="list-create-box">
            <div class="list-create-name">テンプレートタイトル</div>
            <el-form-item prop="list_name">
              <el-input v-model="title" id="autoFocus" placeholder="タイトルを入力してください"></el-input>
            </el-form-item>
            <span style="font-size:10px; color:#aaa">※テンプレートタイトルは受信者には表示されません</span>
          </div>
          <div class="list-create-box phrase">
            <div class="list-create-name">メッセージ内容</div>
            <!-- <div>{{pos_y}}行目・{{pos_x}}列目</div>
            <div>{{offset}}</div>-->
            <div class="newmessage-box border">
              <div
                contenteditable="true"
                class="inbox-phrase-input"
                v-html="html"
                @click="sync()"
                @focus="sync()"
                @input="sync()"
                @keydown.right.exact="sync()"
                @keydown.left.exact="sync()"
                @keydown.down.exact="sync()"
                @keydown.up.exact="sync()"
                @keydown.enter.exact="enter()"
                @keydown.shift.enter.prevent
                @keydown.ctrl.enter.prevent
                @keydown.meta.enter.prevent
                @keydown.alt.enter.prevent
                @paste.prevent
                @paste="paste($event)"
                id="phrase"
              ></div>
              <!-- <pre>{{html}}</pre>
              <pre>{{value}}</pre>-->
              <!-- <div>{{pos_num}}</div> -->
              <div class="inbox-phrase-params-wrap">
                <div style="position: relative">
                  <el-dropdown trigger="click" placement="top">
                    <div class="inbox-phrase-params pointer">
                      <font-awesome-icon :icon="['fas', 'plus-circle']" style="margin-right: 3px;" /> <span class="newmessage-insert-item">パーソナライズ項目を挿入</span>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                      <el-tooltip placement="right">
                        <div slot="content">インフルエンサーの名前を挿入します。</div>
                        <el-dropdown-item @click.native="InsertParams(name_word)">
                          <span class="newmessage-insert-item">名前</span>
                        </el-dropdown-item>
                      </el-tooltip>
                      <el-tooltip placement="right">
                        <div slot="content">インフルエンサーのユーザー名を挿入します。</div>
                        <el-dropdown-item @click.native="InsertParams(accountname_word)">
                          <span class="newmessage-insert-item">ユーザー名</span>
                        </el-dropdown-item>
                      </el-tooltip>
                      <el-tooltip placement="right">
                        <div slot="content">
                          DM用宛名を挿入します。<br />DM用宛名の設定が必要です。未設定の場合はユーザー名が挿入されます。 <br />[リスト]→[表示項目]→[DM宛名]の表示をオンにすると設定できます。
                        </div>
                        <el-dropdown-item @click.native="InsertParams(personalized_name_word)">
                          <span class="newmessage-insert-item">DM用宛名</span>
                        </el-dropdown-item>
                      </el-tooltip>
                      <el-tooltip placement="right">
                        <div slot="content">
                          DM用報酬金額を挿入します。<br />DM用報酬金額の設定が必要です。未設定の場合はブランクとなります。 <br />[リスト]→[表示項目]→[DM報酬金額]の表示をオンにすると設定できます。
                        </div>
                        <el-dropdown-item @click.native="InsertParams(personalized_price_word)">
                          <span class="newmessage-insert-item">DM用報酬金額</span>
                        </el-dropdown-item>
                      </el-tooltip>
                      <el-tooltip placement="right">
                        <div slot="content">
                          フォロワー数に応じた報酬金額を挿入します。
                        </div>
                        <el-dropdown-item @click.native="cost = true">
                          <span class="newmessage-insert-item">報酬金額(フォロワー単価)</span>
                        </el-dropdown-item>
                      </el-tooltip>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <transition name="fade">
                    <div class="data-table-cost-popup top phrase" v-show="cost">
                      <div class="inbox-phrase-popup-title">報酬金額をフォロワー単価で設定</div>
                      <div style="color:#aaa; font-size:11px">
                        フォロワー数に応じて報酬金額が自動で計算・挿入されます。
                        <br />金額は端数が生じないように100円単位の四捨五入で計算されます。
                      </div>
                      <div class="data-table-cost-input-unit">
                        <div class="data-table-cost-input-wrap medium">
                          <span style="margin-right:10px">¥</span>
                          <input type="number" class="data-table-cost-input medium" min="0" step="0.1" v-model="cost_per_unit" />
                        </div>
                        <span style="color:#aaa; margin-left:10px; font-size:11px; width:80%">×フォロワー数</span>
                      </div>
                      <div class="data-table-cost-popup-button">
                        <el-button size="mini" type="default" @click="cancel()" style="width:40%">キャンセル</el-button>
                        <el-button size="mini" type="primary" style="width:60%" @click="insertCost()">報酬金額を挿入</el-button>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>

          <!-- <div>{{ new_html }}</div> -->
          <div class="list-create-footer">
            <el-checkbox class="checkbox-show checkbox-small" v-model="assign" v-if="phrase_type == 'create' && (activate == 11 || activate > 12)">
              自分を担当メンバーに割り当てる
            </el-checkbox>
            <div class="flex-space"></div>
            <div class="inbox-input-length" :class="value_length > 1000 ? 'limit' : ''">{{ value_length }}/1000</div>
            <el-button @click="phrase_drawer = false">キャンセル</el-button>
            <el-button type="primary" :disabled="value_length > 1000" @click="phrase_type == 'edit' ? editPhrase() : createPhrase()">
              <div class="flex-row">
                保存
                <div class="loader--mini" v-show="phrase_loading"></div>
              </div>
            </el-button>
          </div>
        </div>
      </el-form>
      <!-- cost modal bg -->
      <div class="cost-overlay" v-show="cost" @click="cost = false"></div>
      <!-- </el-dialog> -->
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const createPhraseAPI = root + "/api/message/create_phrase";
const editPhraseAPI = root + "/api/message/edit_phrase";

export default {
  name: "phrase",
  props: ["phrase_drawer", "phrase_info", "phrase_type"],
  data() {
    return {
      cost: false,
      cost_per_unit: 1,
      phrase_loading: false,
      title: "",
      html: "",
      // new_html: "",
      value: "",
      pos_num: "",
      offset: 0,
      pos_x: 0,
      pos_y: 0,
      name_word: "{{名前}}",
      name_regexp: new RegExp("{{名前}}", "g"),
      accountname_word: "{{ユーザー名}}",
      accountname_regexp: new RegExp("{{ユーザー名}}", "g"),
      personalized_name_word: "{{DM用宛名}}",
      personalized_name_regexp: new RegExp("{{DM用宛名}}", "g"),
      personalized_price_word: "{{DM用報酬金額}}",
      personalized_price_regexp: new RegExp("{{DM用報酬金額}}", "g"),
      cost_former_word: "{{報酬:フォロワー数×",
      cost_former_regexp: new RegExp("{{報酬:フォロワー数×", "g"),
      cost_latter_word: "円}}",
      cost_latter_regexp: new RegExp("円}}", "g"),
      name_params: '&#8203;<span contenteditable="false">&#8203;​<span class="inbox-phrase-params-in pointer">{{名前}}</span>&#8203;</span>&#8203;',
      accountname_params: '&#8203;<span contenteditable="false">&#8203;<span class="inbox-phrase-params-in pointer">{{ユーザー名}}</span>&#8203;</span>&#8203;',
      personalized_name_params: '&#8203;<span contenteditable="false">&#8203;​<span class="inbox-phrase-params-in pointer">{{DM用宛名}}</span>&#8203;</span>&#8203;',
      personalized_price_params: '&#8203;<span contenteditable="false">​&#8203;<span class="inbox-phrase-params-in pointer"><span>{{DM用報酬金額}}</span></span>&#8203;</span>&#8203;',
      cost_former_params: '&#8203;<span contenteditable="false">&#8203;<span class="inbox-phrase-params-in pointer">{{報酬:フォロワー数×',
      cost_latter_params: "円}}</span>&#8203;</span>&#8203;",
      assign: true,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    activate() {
      return this.$store.state.activate;
    },
    cost_word() {
      return "{{報酬:フォロワー数×" + this.cost_per_unit + "円}}";
    },
    childNodesNum() {
      return document.getElementById("phrase").childNodes.length;
    },
    value_length() {
      var name_num = this.value.match(new RegExp("{{名前}}", "g"));
      var account_name_num = this.value.match(new RegExp("{{ユーザー名}}", "g"));
      var personalized_name_num = this.value.match(new RegExp("{{DM用宛名}}", "g"));
      var personalized_price_num = this.value.match(new RegExp("{{DM用報酬金額}}", "g"));
      var price_num = this.value.match(new RegExp("{{報酬:フォロワー数", "g"));
      if (!name_num && !account_name_num && !price_num) {
        return this.value.length;
      } else {
        var length =
          this.value.length +
          (name_num ? 18 * name_num.length : 0) +
          (account_name_num ? 17 * account_name_num.length : 0) +
          (personalized_name_num ? 18 * personalized_name_num.length : 0) +
          (personalized_price_num ? 18 * personalized_price_num.length : 0) +
          (price_num ? 8 * price_num.length : 0);
        return length;
      }
    },
  },
  mounted() {
    this.setContent();
    this.getPos();
    setTimeout(() => {
      this.movePos();
    }, 200);
  },
  methods: {
    setContent() {
      if (this.phrase_type == "edit") {
        let regex = /<br>(?!<\/div>)/ig
        this.title = this.phrase_info.phrase_title;
        this.html = this.phrase_info.phrase_html.replace(regex, "");
        this.new_html = this.phrase_info.phrase_html.replace(regex, "");
        this.value = this.phrase_info.phrase_content;
      }
    },
    cancel() {
      this.cost = false;
    },
    sync() {
      var new_html = document.getElementById("phrase").innerHTML;
      // console.log(new_html);
      new_html = new_html.replace(/\n/gi, ""); //無駄な改行コードを排除
      // console.log(new_html);
      // new_html = new_html.replace(/([^>]+)<br><\/div>/ig, "</div>") //無駄な改行コードを排除
      // console.log(new_html)
      new_html = new_html.replace(/<div class="inbox-phrase-block"><\/div>/gi, ""); //無駄な改行コードを排除
      // console.log(new_html);
      this.new_html = new_html;
      var nodes = document.getElementById("phrase").childNodes;
      // console.log(nodes)
      var value = "";
      for (let i = 0; i < nodes.length; i++) {
        var textContent = nodes[i].textContent;
        textContent = textContent.replace(/\n/gi, ""); //無駄な改行コードを排除
        value += textContent + "\n";
      }
      // console.log(value)
      this.value = value;
      setTimeout(() => {
        this.getPos();
      }, 100);
    },
    enter() {
      document.execCommand("DefaultParagraphSeparator", false, "div");
    },
    paste(e) {
      var text = e.clipboardData.getData("text/plain");
      document.execCommand("insertText", false, text);
    },
    getPos() {
      if (!document.getElementById("phrase").childNodes[0]) {
        document.execCommand("insertHTML", false, '<div class="inbox-phrase-block"><br></div>');
      } else {
        var range = window.getSelection();
        // console.log(range);
        var rangeCount = 0;
        var childNodes = document.getElementById("phrase").childNodes;
        var select = window.getSelection();
        var selectedOffsetTop = 0;
        if (select.anchorNode.nodeType == 3) {
          selectedOffsetTop = select.anchorNode.parentNode.offsetTop;
        } else {
          selectedOffsetTop = select.anchorNode.offsetTop;
        }
        this.offset = selectedOffsetTop;
        // console.log(childNodes);
        for (var i = 0; i < childNodes.length; i++) {
          // if (childNodes[i].outerHTML) {
          rangeCount += childNodes[i].outerHTML.length;
          if (childNodes[i].offsetTop == selectedOffsetTop) break;
          // } else if (childNodes[i].nodeType == 3) {
          //   rangeCount += childNodes[i].textContent.length;
          //   if (childNodes[i].parentNode.offsetTop == selectedOffsetTop) break;
          // }
        }
        this.pos_y = i;
        //xを決定
        if (childNodes[i].childNodes.length <= 1) {
          this.pos_x = range.anchorOffset;
        } else {
          var anchorData = range.anchorNode.data;
          var anchorCount = 0;
          for (let ii = 0; ii < childNodes[i].childNodes.length; ii++) {
            if (childNodes[i].childNodes[ii].nodeType == 3) {
              if (childNodes[i].childNodes[ii].data == anchorData) break;
              anchorCount += childNodes[i].childNodes[ii].length;
            } else if (childNodes[i].childNodes[ii].textContent) {
              if (childNodes[i].childNodes[ii].textContent == anchorData) break;
              anchorCount += childNodes[i].childNodes[ii].textContent.length;
            } else if (childNodes[i].childNodes[ii].wholeText) {
              if (childNodes[i].childNodes[ii].wholeText == anchorData) break;
              anchorCount += childNodes[i].childNodes[ii].wholeText.length;
            }
          }
          this.pos_x = anchorCount + range.anchorOffset;
        }
        this.pos_num = rangeCount + this.pos_x;
      }
    },
    InsertParams(word) {
      var node = document.getElementById("phrase").childNodes[this.pos_y];
      if (!node) {
        var OuterHtml = this.name_params;
      } else {
        var text = node.textContent;
        var before = text.substr(0, this.pos_x);
        var after = text.substr(this.pos_x, text.length);
        OuterHtml = '<div class="inbox-phrase-block">' + before + word + after + "<br></div>";
        var html = OuterHtml.replace(this.accountname_regexp, this.accountname_params);
        html = html.replace(this.name_regexp, this.name_params);
        html = html.replace(this.personalized_name_regexp, this.personalized_name_params);
        html = html.replace(this.personalized_price_regexp, this.personalized_price_params);
        html = html.replace(this.cost_former_regexp, this.cost_former_params);
        var NewOuterHtml = html.replace(this.cost_latter_regexp, this.cost_latter_params);
        node.outerHTML = NewOuterHtml;
      }
      setTimeout(() => {
        this.movePos();
      }, 200);
    },
    movePos() {
      var node = document.getElementById("phrase").childNodes[this.pos_y];
      if (!node) {
        node = document.getElementById("phrase");
      }
      var selection = window.getSelection();
      var range = document.createRange();
      range.setStart(node, node.childNodes.length ? node.childNodes.length : node.length);
      range.collapse(true);
      selection.removeAllRanges();
      selection.addRange(range);
    },
    insertCost() {
      this.InsertParams(this.cost_word);
      this.cost = false;
    },
    createPhrase() {
      if (this.value_length > 1000) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "メッセージが長すぎます",
        });
      } else {
        this.phrase_loading = true;
        var params = new URLSearchParams();
        params.append("phrase_title", this.title);
        params.append("phrase_content", this.value);
        params.append("phrase_html", this.new_html);
        params.append("assign", this.activate == 11 || this.activate > 15 ? this.assign : false);
        params.append("user_token", this.user_token);
        params.append("token", this.token);
        this.axios.post(createPhraseAPI, params).then(() => {
          this.phrase_loading = false;
          this.$emit("closePhrase");
          this.$emit("loadPhrase");
          this.$message({
            type: "success",
            offset: 7,
            showClose: true,
            message: "テンプレートを作成しました",
          });
        });
      }
    },
    editPhrase() {
      // console.log(this.new_html);
      this.phrase_loading = true;
      var params = new URLSearchParams();
      params.append("phrase_title", this.title);
      params.append("phrase_content", this.value);
      params.append("phrase_html", this.new_html);
      params.append("phrase_id", this.phrase_info.phrase_id);
      params.append("token", this.token);
      this.axios.post(editPhraseAPI, params).then(() => {
        this.phrase_loading = false;
        this.$emit("closePhrase");
        this.$emit("loadPhrase");
        this.$message({
          type: "success",
          offset: 7,
          showClose: true,
          message: "テンプレートを編集しました",
        });
      });
    },
  },
  filters: {},
  watch: {
    phrase_drawer() {
      if (this.phrase_drawer == false) {
        this.$emit("closePhrase");
      }
    },
  },
};
</script>
